let currentUrl = window.location.href;
let url = '';
currentUrl = currentUrl.substring(currentUrl.indexOf("://") + 3);
url = url.substring(0, currentUrl.indexOf("/"));
export const API_URL = {

    index () {
        // return `http://localhost/krbs_api/public/api/memo_circular`;
        return `${url}/krbs_api/public/api/memo_circular`;
    },
    ragUrl(){
        return 'https://elitesdsi.com/'
    }
};

// export const SERVER_URL = `http://localhost/KRBS`;
export const SERVER_URL = url;

export default { API_URL }